import { combineReducers } from 'redux';

import reducerApp from 'index/AppReducer';
import reducerArticle from 'components/Article/ArticleReducer';
import reducerBannerVideo from 'screens/Collection/components/VideoBanner/components/BannerVideo/Reducer';
import reducerBio from 'screens/SeriesDetail/components/Bio/BioReducer';
import reducerBlackoutDefinitionFetcher from 'components/BlackoutDefinitionFetcher/BlackoutDefinitionFetcherReducer';
import reducerCanIAutoplay from 'components/CanIAutoplay/Reducer';
import reducerClips from 'screens/ContentDetail/components/Clips/ClipsReducer';
import reducerCollection from 'screens/Collection/Reducer';
import reducerDebug from 'screens/Debug/DebugReducer';
import reducerEmailSubmissionForm from 'components/EmailSubmissionForm/EmailSubmissionFormReducer';
import reducerFooter from 'components/Footer/FooterReducer';
import reducerFooterUpsell from 'components/FooterUpsell/FooterUpsellReducer';
import reducerHoverMenu from 'components/Header/HoverMenu/HoverMenuReducer';
import reducerLatestEpisode from 'screens/LatestEpisode/LatestEpisodeReducer';
import reducerLive from 'screens/Live/LiveReducer';
import reducerNavSchedule from 'components/NavSchedule/NavScheduleReducer';
import reducerPanel from 'components/Panel/PanelReducer';
import reducerPhotoGallery from 'screens/SeriesDetail/components/PhotoGallery/PhotoGalleryReducer';
import reducerPromoList from 'components/PromoList/PromoListReducer';
import reducerSearch from 'screens/Search/Reducer';
import reducerSeriesDetail from 'screens/SeriesDetail/SeriesDetailReducer';
import reducerShows from 'screens/Shows/ShowsReducer';
import reducerSiteMap from 'screens/SiteMap/SiteMapReducer';
import reducerVideoModal from 'components/VideoModal/VideoModalReducer';
import reducerVideoPlayerGlobal from 'components/VideoPlayerGlobal/Reducer';
import reducerVideosTab from 'screens/SeriesDetail/components/VideosTab/VideosTabReducer';
import reducerWatch from 'screens/Watch/WatchReducer';

const rootReducer = combineReducers({
  app: reducerApp,
  article: reducerArticle,
  bannerVideo: reducerBannerVideo,
  bio: reducerBio,
  blackoutDefinitionFetcher: reducerBlackoutDefinitionFetcher,
  canIAutoplay: reducerCanIAutoplay,
  clips: reducerClips,
  collection: reducerCollection,
  debug: reducerDebug,
  emailSubmissionForm: reducerEmailSubmissionForm,
  footer: reducerFooter,
  footerUpsell: reducerFooterUpsell,
  globalVideo: reducerVideoPlayerGlobal,
  hoverMenu: reducerHoverMenu,
  latestEpisode: reducerLatestEpisode,
  live: reducerLive,
  navSchedule: reducerNavSchedule,
  panel: reducerPanel,
  photoGallery: reducerPhotoGallery,
  promoList: reducerPromoList,
  search: reducerSearch,
  seriesDetail: reducerSeriesDetail,
  shows: reducerShows,
  siteMap: reducerSiteMap,
  videoModal: reducerVideoModal,
  videosTab: reducerVideosTab,
  watch: reducerWatch,
});

export default rootReducer;
